import hashObject from 'object-hash';

export const hash = (obj: string | object): string => {
  return hashObject(obj);
};

export const currentUrl = (): string => {
  if (!window) return '';

  return window.location.href;
};

const sanitiseString = (input: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(input, 'text/html');
  return doc.body.textContent || '';
};

export const toCamelCase = (input: string): string => {
  return input
    .toLowerCase()
    .trim()
    .split(' ')
    .map((word, index) => {
      if (index === 0) {
        return word;
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join('');
};

export const toTitleCase = (text: string): string => {
  // List of words to ignore (prepositions, conjunctions, articles)
  const minorWords = new Set([
    'a',
    'an',
    'and',
    'but',
    'or',
    'nor',
    'for',
    'on',
    'in',
    'at',
    'to',
    'from',
    'by',
    'the',
    'with',
    'of',
  ]);

  // Special phrases that should be capitalized as-is
  const specialCases = ['TM Forum'];

  let skipNextWord = false; // Flag to skip words that are part of a special case

  return text
    .split(' ') // Split the text into individual words
    .map((word, index, words) => {
      if (skipNextWord) {
        skipNextWord = false; // Reset flag after skipping
        return ''; // Skip this word in the final output
      }

      // Join words back together to check for special phrases like "TM Forum"
      const joinedPhrase = words.slice(index, index + 2).join(' ');

      // If the joined phrase matches a special case, handle it
      if (specialCases.includes(joinedPhrase)) {
        skipNextWord = true; // Skip the next word in the loop
        return joinedPhrase; // Return the special case as is
      }

      // Capitalize the first word or any word that is not in the minorWords list
      if (index === 0 || !minorWords.has(word.toLowerCase())) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }

      return word.toLowerCase(); // Leave minor words in lowercase
    })
    .filter(Boolean) // Filter out any empty results from skipped words
    .join(' '); // Rejoin the words into a single string
};

export const convertToClassName = (text: string): string =>
  text
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');

export const shareCurrentUrl = (
  title: string,
  type: string,
  url: string
): string => {
  switch (type) {
    case 'linkedin':
      return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
        url
      )}`;

    case 'twitter':
    case 'x':
      return `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        url
      )}&text=${encodeURIComponent(title)}`;

    case 'email':
    default:
      return `mailto:?subject=Check out this page&body=I found this interesting, ${sanitiseString(
        title
      )}:  ${url}`;
  }
};

export const scrollToDiv = (id: string) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

export function getChartColors() {
  return ['#973994', '#AEC9F0', '#AABE3B', '#F09832'];
}

export function getSlicePath(radius: number, angle: number) {
  const radians1 = (-180 * Math.PI) / 180;
  const x1 = radius * Math.sin(radians1) + 50;
  const y1 = radius * Math.cos(radians1) + 50;
  const radians2 = ((360 - angle - 180) * Math.PI) / 180;
  const x2 = radius * Math.sin(radians2) + 50;
  const y2 = radius * Math.cos(radians2) + 50;
  const large = angle > 180 ? '1' : '0';

  return `M ${x1} ${y1} A ${radius} ${radius} 0 ${large} 1 ${x2} ${y2} L 50 50 Z`;
}
